module.exports = __webpack_public_path__ + "static/media/sto.17e7a4ac.svg";